import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-grey-darkest w-full h-full overflow-y-scroll text-14" }
const _hoisted_2 = { class: "py-2" }

import { computed } from 'vue';
import format from 'date-fns/format';

type CsgTerms = {
  brand: string,
  firstName: string,
  lastName: string,
  phone: string,
  address: string,
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CsgTerms',
  props: {
    brand: {},
    firstName: {},
    lastName: {},
    phone: {},
    address: {}
  },
  setup(__props: any) {

const currentDate = computed(() => {
  return format(new Date(), 'EEEE \'the\' do \'of\' MMMM, yyyy');
});

const serviceProviderDetails = computed(() => {
  return `${props.brand}, ${props.address}`;
});

const name = computed(() => {
  return `${props.firstName} ${props.lastName}`;
});

const props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("p", { class: "font-bold text-16 pb-2" }, " Customer Service Guarantee ", -1)),
    _cache[4] || (_cache[4] = _createElementVNode("p", { class: "font-bold py-2" }, " You acknowledge and agree as follows: ", -1)),
    _createElementVNode("p", _hoisted_2, _toDisplayString(props.brand) + " Talk is a VoIP phone service which is provided over your Internet connection. It is necessary for you to agree to the following Customer Service Guarantee Waiver before we can supply you with the VoIP service you have ordered. ", 1),
    _cache[5] || (_cache[5] = _createElementVNode("p", { class: "py-2" }, " We need you to do this because we cannot guarantee the date of provisioning or the restoration time of your VoIP service if a fault occurs with the internet or your underlying physical connection that supports your Internet service. ", -1)),
    _cache[6] || (_cache[6] = _createElementVNode("p", { class: "py-2" }, " The wavier means that you cannot claim compensation if we fail to meet set standards for connection times, fault restoration, and appointment times. The wavier does not stop you from contacting us about a fault with your service and we will always do our best to restore or provision your service as quickly as possible. ", -1)),
    _cache[7] || (_cache[7] = _createElementVNode("p", { class: "font-bold py-2 mt-4" }, " This waiver applies to the VoIP service that you have ordered. ", -1)),
    _createElementVNode("p", null, [
      _createTextVNode(" Customer Name: " + _toDisplayString(name.value) + " ", 1),
      _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
      _createTextVNode(" Date of Waiver: " + _toDisplayString(currentDate.value) + " ", 1),
      _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
      _createTextVNode(" Service Provider's Details: " + _toDisplayString(serviceProviderDetails.value) + " ", 1),
      _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
      _createTextVNode(" Phone: " + _toDisplayString(props.phone), 1)
    ]),
    _cache[8] || (_cache[8] = _createStaticVNode("<p class=\"font-bold py-2 mt-4\"> Customer Service Guarantee </p><p class=\"py-2\"> Information about the Customer Service Guarantee (CSG) may be found on the Australian Communications and Media Authority&#39;s website <a href=\"https://www.acma.gov.au\">www.acma.gov.au</a>. The CSG requires us to meet performance standards for standard telephone services. The minimum CSG requirements are: </p><ul><li>(a) Providing written information at least every two years (or upon request at any time) about the CSG performance standards, our obligations and your right to compensation under the CSG;</li><li>(b) Guaranteed maximum periods to connect new services;</li><li>(c) Guaranteed maximum periods for fault rectification;</li><li>(d) Maximum time frames for customer appointments;</li></ul><p class=\"py-2\"> The CSG contains exceptions for certain events such as extreme weather. If we do not meet the requirements and an exception doesn&#39;t apply, you may be entitled to compensation under the CSG. </p><p class=\"font-bold py-2 mt-4\"> Consequences of the waiver of the CSG </p><p class=\"py-2\"> By agreeing to this waiver you will not be entitled to any CSG rights. Specifically, you will not be entitled to being provided with written information about the CSG, guaranteed maximum connection periods, guaranteed maximum rectification periods and maximum time frames for appointments. You will not be entitled to compensation for failure to meet such performance standards. </p><p class=\"py-2\"> You have no obligation to consent to the proposed waiver; however, if you do not consent we have the right to decline your application. </p>", 7))
  ]))
}
}

})